import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const ConsentBanner = () => {
    const [choice, setChoice] = useState(() => localStorage.getItem("ds_consent"));

    useEffect(() => {
        if (choice === "declined") {
            window.posthog?.opt_out_capturing?.();
        } else if (choice === "accepted") {
            window.posthog?.opt_in_capturing?.();
        }
    }, [choice]);

    const decide = (v) => {
        localStorage.setItem("ds_consent", v);
        setChoice(v);
    };

    return (
        <AnimatePresence>
            {!choice && (
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0, transition: { delay: 3, duration: 0.6 } }}
                    exit={{ opacity: 0, y: 20, transition: { duration: 0.3 } }}
                    data-testid="consent-banner"
                    className="fixed bottom-6 left-5 right-5 z-[70] mx-auto max-w-md rounded-2xl border border-purple-500/30 bg-[#0b031e]/90 p-5 shadow-[0_8px_40px_rgba(0,0,0,0.6)] backdrop-blur-xl sm:right-auto"
                >
                    <p className="font-cinzel text-[11px] tracking-[0.2em] text-[#e0aaff]">A LITTLE ANALYTICS MAGIC</p>
                    <p className="mt-2 font-cormorant text-sm italic leading-relaxed text-[#e0aaff]/75">
                        This mirror counts its visitors anonymously — no names, no stories, nothing personal. Your words
                        to Mara are never part of it.
                    </p>
                    <div className="mt-4 flex gap-3">
                        <button type="button" onClick={() => decide("accepted")} data-testid="consent-accept" className="btn-ghost-glow !px-5 !py-2 !text-[10px]">
                            ALLOW
                        </button>
                        <button
                            type="button"
                            onClick={() => decide("declined")}
                            data-testid="consent-decline"
                            className="font-cinzel text-[10px] tracking-[0.2em] text-[#c77dff]/60 transition-colors duration-300 hover:text-[#e0aaff]"
                        >
                            DECLINE
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
